<template>
    <div class="terminos">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-9 col-lg-9">
                    <h3>Aspirante {{ user.state.name }} {{user.state.primerApellido}}</h3>
                    <p>Lea la siguiente información con atención, está a punto de comenzar la prueba técnica para la
                        siguiente categoria de licencia: <br>
                    <ul>
                        <li>Licencia categoria {{user.state.categoriaLicencia}}</li>
                        <!-- <li>licencia categoria 00</li> -->
                    </ul>
                    El contenido de la prueba corresponde a 40 preguntas de selección multiple que evalúan sus actitudes
                    y conocimientos en: <br>
                    <ul>
                        <li>Movilidad segura y sostenible</li>
                        <li>Normas de tránsito</li>
                    </ul>

                    El desarrollo de la prueba debe realizarse de manera individual y sin el apoyo de dispositivos
                    informáticos adicionales a la estación de trabajo donde presenta la prueba. El incumplimiento de esto puede llevar a la anulación de la prueba
                    y sanciones según corresponda.<br> <br>

                    Tenga en cuenta que la prueba tiene una duración de 70 minutos, durante el desarrollo de la misma,
                    en la parte superior de la pantalla se le irá notificando los minutos restantes para la finalización de 
                    la prueba.<br> <br>

                    Durante el transcurso de la prueba se les tomarán [X] cantidad de fotos en intérvalos aleatorios para verificar su identidad durante la presentación de la prueba.<br>
                    Para comenzar el examen acepta los términos y condiciones.
                    </p>
                    <input type="checkbox" name="terminos" id="check" v-model="habilitar" >
                     <label for="check" class="condiciones">Acepto términos y condiciones del examen </label> 
                     <br>
                    <div class="continuar">
                        <button id="button" :disabled="!habilitar" @click="ingresar">
                            CONTINUAR
                        </button>
                    
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useStore } from 'vuex'
 import { onMounted, computed} from 'vue'

// import axios from 'axios'
export default {

    name: 'InicioPage',
    data() {
        return {

            habilitar: null,
        }
    },
    mounted(){
        this.$store.commit('setTextoHeader',2)
        this.deshabilitaRetroceso();
    },
 
    setup() {
        const user = useStore();
        onMounted(() => {
            user.dispatch('fetchDataParametros');
            // store.dispatch('Login');
        })
        const numeronoti = computed(() => user.state.parametros);
        //const  = computed()=>
        return { user, numeronoti }
    },
    methods: {
        ingresar() {
            this.$router.push('/aspirante')
        },
        deshabilitaRetroceso() {
            window.location.hash = "no-back-button";
            window.location.hash = "Again-No-back-button" //chrome
            window.onhashchange = function () { window.location.hash = ""; }
            return;
        }
    },
}
</script>

<style lang="scss">
.terminos {
    font-family: 'Montserrat', sans-serif;
    background: #f0f0f0;
    padding-top: 5%;
    padding-bottom: 5%;

    h3 {
        font-weight: 600;

    }
    .condiciones{
        margin-left: 10px;
    }

    .continuar {
        justify-content: center;
        align-items: center;
        display: flex;
         #button{ 
            height: 32px;
            font-size: 14px;
            margin-top: 3%;
            padding: 4px;
            border-radius: 15px;
            border: none;

            &:disabled{
                background-color: none;

                &:hover {
                background-color: none;
            }
            }
            &:enabled{
                background-color: #071D49;
                border-color: #071D49;
                color: #f0f0f0;
                cursor: pointer;
                padding: 6px;

             &:hover {
                background-color: #00b5e2;
                border-color: #00b5e2;
                color: #f0f0f0;
            }
            }
        }
    }

}
</style> 

